import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants'

export default (theme: APTheme) => createStyles({
    root: {
        marginRight: 10,
        marginLeft: 16
    },
    badgeIcon: {
        width: 24,
        height: 27,
        '& .MuiBadge-badge': {
            fontSize: 13,
            top: 5,
        },
    },
    notificationBellIcon: {
        width: 24,
        height: 27,
    }
});